import * as React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

type MiniStatProgressProps = {
    value: number;
    total?: number;
    size?: number;
    color?: string;
    trackColor?: string;
};

export const MiniStatProgress: React.FC<MiniStatProgressProps> = ({
    value,
    total = 10,
    size = 32,
    color = "primary.main",
    trackColor = "action.disabledBackground",
}) => {
    const remaining = Math.max(0, total - value);

    const percent = (remaining / total) * 100;

    const dynamicColor =
        value === 0
            ? "success.main"
            : value < total / 2
                ? color
                : value < total
                    ? "warning.main"
                    : "error.main";

    return (
        <Box sx={{ position: "relative", width: size, height: size }}>
            {/* track */}
            <CircularProgress
                variant="determinate"
                value={100}
                size={size}
                thickness={5}
                sx={{ color: trackColor }}
            />

            {/* progress */}
            <CircularProgress
                variant="determinate"
                value={percent}
                size={size}
                thickness={5}
                sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    color: dynamicColor,
                }}
            />

            {/* number */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 800,
                        fontSize: 16,
                        lineHeight: 1,
                    }}
                >
                    {value}
                </Typography>
            </Box>
        </Box>
    );
};
